import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot, TextNode } from 'lexical'
import { SelectNode } from '../nodes/selectNode'
import { InputNode } from '../nodes/inputNode'
import { extractText } from '../utils'

export function MaxLengthPlugin({ maxLength }) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const root = $getRoot()
        if (extractText(root).length <= maxLength) return

        editor.update(() => {
          let remain = maxLength
          const visit = node => {
            if (remain <= 0) { node.remove?.(); return }
            if (node instanceof TextNode) {
              const t = node.getTextContent()
              if (t.length > remain) { node.setTextContent(t.slice(0, remain)); remain = 0 } else remain -= t.length
              return
            }
            if (node instanceof SelectNode || node instanceof InputNode) {
              const v = node.__props?.value ?? ''
              if (v.length > remain) { node.__props.value = v.slice(0, remain); remain = 0 } else remain -= v.length
              return
            }
            if (node.getChildren) node.getChildren().forEach(visit)
          }
          visit(root)
        })
      })
    })
  }, [editor, maxLength])

  return null
}
